<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>Filtrowanie</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          lg="3"
          class="mb-md-0 mb-2"
        >
          <label>Dzień od</label>
          <clearable-form-datepicker
            :value="dayFilterFrom"
            locale="pl"
            hide-header
            label-help=""
            placeholder="Dowolny"
            @input="val => $emit('update:dayFilterFrom', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          lg="3"
          class="mb-md-0 mb-2"
        >
          <label>Dzień do</label>
          <clearable-form-datepicker
            :value="dayFilterTo"
            locale="pl"
            hide-header
            label-help=""
            placeholder="Dowolny"
            @input="val => $emit('update:dayFilterTo', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          lg="3"
          class="mb-md-0 mb-2"
        >
          <label>Rodzaj</label>
          <v-select
            :value="kindFilter"
            :options="kindOptions"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Dowolny"
            :clearable="true"
            @input="val => $emit('update:kindFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          lg="3"
          class="mb-md-0 mb-2"
        >
          <label>Dział</label>
          <v-select
            :value="departmentFilter"
            :options="departmentOptions"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Dowolny"
            :clearable="true"
            @input="val => $emit('update:departmentFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          lg="3"
          class="mb-md-0 mb-2"
        >
          <label>Egzaminator</label>
          <v-select
            :value="examinerFilter"
            :options="examinerOptions"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Dowolny"
            :clearable="true"
            @input="val => $emit('update:examinerFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          lg="3"
          class="mb-md-0 mb-2"
        >
          <label>Lokalizacja</label>
          <b-form-input
            :value="localizationFilter"
            placeholder="Szukaj w lokalizacji"
            @input="val => $emit('update:localizationFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          lg="3"
          class="mb-md-0 mb-2"
        >
          <label>Status</label>
          <v-select
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Dowolny"
            :clearable="true"
            @input="val => $emit('update:statusFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ClearableFormDatepicker from '@core/components/clearable-form-datepicker/ClearableFormDatepicker.vue'
import departmentOptions from '@/helpers/departmentOptions'
import certificationKindOptions from '@/helpers/certificationKindOptions'
import certificationStatusOptions from '@/helpers/certificationStatusOptions'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    ClearableFormDatepicker,
    vSelect,
  },
  props: {
    dayFilterFrom: {
      type: [String, null],
      default: null,
    },
    dayFilterTo: {
      type: [String, null],
      default: null,
    },
    kindFilter: {
      type: [String, null],
      default: null,
    },
    departmentFilter: {
      type: [String, null],
      default: null,
    },
    examinerFilter: {
      type: [String, null],
      default: null,
    },
    localizationFilter: {
      type: String,
      default: '',
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    examinerOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      departmentOptions,
      kindOptions: certificationKindOptions,
      statusOptions: certificationStatusOptions,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
